import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { getDealerContexts } from '../../api/backendApi';
import { useAuth } from '../../contexts/AuthContext';
import { useDealerAdmin } from '../../contexts/DealerAdminContext';
import { dealerAdminReturnPath } from '../../pages/Admin/dealerAdminNav';
import { ROUTES } from '../../utils/constants';
import { isOperatorShellRole } from '../../utils/sessionRole';

export default function DealerWorkspaceLink({ variant = 'sidebar' }) {
  const { role } = useAuth();
  const dealerAdmin = useDealerAdmin();
  const [visible, setVisible] = useState(false);
  const dest = dealerAdminReturnPath({
    dealerId: dealerAdmin.dealerId,
    tenantId: dealerAdmin.tenantId,
  });

  useEffect(() => {
    let cancelled = false;
    getDealerContexts()
      .then((response) => {
        const rows = Array.isArray(response?.data) ? response.data : [];
        if (!cancelled) setVisible(rows.length > 0);
      })
      .catch(() => {
        if (!cancelled) setVisible(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!visible || isOperatorShellRole(role)) return null;

  if (variant === 'header') {
    return (
      <Link
        to={dest}
        className="flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        Dealer
      </Link>
    );
  }

  return (
    <li>
      <NavLink
        to={dest}
        className={({ isActive }) =>
          `flex items-center py-1.5 px-3 text-sm text-white hover:bg-gray-700 transition-colors ${isActive ? 'bg-gray-700' : ''}`
        }
      >
        <span>Dealer workspace</span>
      </NavLink>
    </li>
  );
}
